export default [    //服务卡销售
  {
    path: "/salesAdd",    //服务卡销售
    name: 'salesAdd',
    component: () => import("@/views/cardSales/salesAdd.vue")
  },
  {
    path: "/salesRecord",    //服务卡记录
    name: 'salesRecord',
    component: () => import("@/views/cardSales/salesRecord.vue")
  }
]
